export interface TierMengenRow {
    anzahl?: number | null;
    anzahl_mit_gewicht?: number | null;
    gesamtgewicht?: number | null;
}

export function formatTierMengenLabel(row: TierMengenRow | null | undefined): string {
    const n = Number(row?.anzahl ?? 0);
    const tiere = `${Number.isFinite(n) ? n : 0} Tiere`;
    if (row?.anzahl_mit_gewicht == null && row?.gesamtgewicht == null) {
        return tiere;
    }
    const mit = Number(row?.anzahl_mit_gewicht ?? 0);
    const ohne = Math.max(0, (Number.isFinite(n) ? n : 0) - (Number.isFinite(mit) ? mit : 0));
    if (!(mit > 0)) {
        return `${tiere}, keine Gewichte`;
    }
    const kg = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
    }).format(Number(row?.gesamtgewicht ?? 0));
    if (ohne > 0) {
        return `${mit} Tiere mit ${kg} kg und ${ohne} ohne Gewicht`;
    }
    return `${mit} Tiere mit ${kg} kg`;
}
